import React from 'react';
import { Container, Link, Img } from './styles';
import SgetdigGov from '../../assets/setdiggov.svg';
// import { Container } from './styles';

function Footer() {
  return (
    <Container>
      <Link href="http://www.ms.gov.br" target="_blank" rel="noopener noreferrer">
        <Img src={SgetdigGov} alt="sgi" />
      </Link>
    </Container>
  );
}

export default Footer;